﻿export const PAGE_SIZE = 20;
export const DEVICE_OPTIONS = [{ value: 'SMARTPHONE' }, { value: 'TABLET' }, { value: 'DESKTOP' }];
export const MOBILE_PLATFORMS = ['IOS', 'ANDROID', 'WINDOWS'] as const;
export const MESSAGE_SEGMENTS = ['MCS', 'OPT', 'DENT'] as const;
export const DEFAULT_LOCALE = 'EN';
export const LOCALES = [
  { key: DEFAULT_LOCALE, label: 'English' },
  { key: 'DE', label: 'Deutsch' },
  { key: 'FR', label: 'Français' },
  { key: 'ES', label: 'Español' },
  { key: 'IT', label: 'Italiano' },
  { key: 'PT', label: 'Português' },
  { key: 'PT-BR', label: 'Português (Brazil)' },
  { key: 'ZH', label: 'Chinese' },
] as const;
export const DEFAULT_CODE = 'df';
export const MEDIA_ASSET_FILE_ACCEPT =
  '.pdf, .mp4, .ppt, .pptx, .jpg, .jpeg, .png, .m4v, .zip, .xls, .xlsx, .doc, .docx';
// The only public audience; every other target group is internal, and internal
// link assets may not be handed to the device browser.
export const PUBLIC_TARGET_GROUP_NAME = 'Public';
export const CATALOG_IMPORT_FILE_EXTENSIONS = ['.xls', '.xlsx'];
export const CATALOG_IMPORT_FILE_ACCEPT = CATALOG_IMPORT_FILE_EXTENSIONS.join(', ');
export const BACKEND_ROLES = ['SUPER_ADMIN', 'ADMIN', 'MANAGER'];
export const RICH_TEXT_IMAGE_TYPES = ['image/png', 'image/jpeg'];
export const RICH_TEXT_IMAGE_ACCEPT = RICH_TEXT_IMAGE_TYPES.join(',');
export const RICH_TEXT_IMAGE_MAX_SIZE = 5 * 1024 * 1024;
export const RICH_TEXT_IMAGE_MAX_SIZE_LABEL = '5 MB';
